import React from 'react';
import styles from './Loading.module.css';
import LoadingGif from '../../assets/loading.svg';
import Scrim from '../@base/Scrim';

const Loading = (props) => (
  <Scrim classes="is-foco">
    <div className={styles.SimpleLoading}>
      <img src={LoadingGif} alt="carregamento" />
      <p>{props.message ? props.message : 'Carregando...'}</p>
    </div>
  </Scrim>
);

export default Loading;
